export default __webpack_public_path__ + "static/media/logo-vuz-sk.9509ad96.svg";